import React from 'react';
import { Grid } from '@mui/material';
import AppLayout from '../../layout/app.layout';
import PurchasedSubscriptionsChart from '../../components/reports/subscription-summary-chart.component';
import PAGE_TITLE_LIST from '../../config/page-title.config';

const ReportsSubscriptionsView = () => {
  const pageTitle = PAGE_TITLE_LIST.REPORTS_SUBSCRIPTIONS;

  return (
    <AppLayout pageTitle={pageTitle}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <PurchasedSubscriptionsChart />
        </Grid>
      </Grid>
    </AppLayout>
  );
};

export default ReportsSubscriptionsView;
